export default __webpack_public_path__ + "static/media/solla.dfe64ad0.png";